/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
function isObject<O extends object>(obj: O) {
    return (
        obj !== null &&
        typeof obj === 'object' &&
        !(obj instanceof Date) &&
        !(obj instanceof RegExp) &&
        !Array.isArray(obj)
    );
}

function merge2<T extends object, S extends object>(src1: T, src2: S): T & S {
    const dst = { ...(src1 as object) } as T & S;
    Object.keys(src1).forEach((key) => (dst[key] = src1[key]));
    Object.keys(src2).forEach((key) => {
        const value1 = src1[key];
        const value2 = src2[key];
        if (Array.isArray(value1) && Array.isArray(value2)) {
            dst[key] = value1.concat(value2);
        } else if (isObject(value1) && isObject(value2)) {
            dst[key] = merge2(value1, value2);
        } else {
            dst[key] = value2;
        }
    });
    return dst;
}

function merge(...sources: any[]) {
    return sources.reduce(merge2);
}

export { merge as default, merge, merge2 };
